import {
  FETCH_DEPARTMENT_GROUP_REQUEST,
  FETCH_DEPARTMENT_GROUP_SUCCESS,
  FETCH_DEPARTMENT_GROUP_FAILURE,
  ADD_DEPARTMENT_GROUP_REQUEST,
  ADD_DEPARTMENT_GROUP_SUCCESS,
  ADD_DEPARTMENT_GROUP_FAILURE,
  UPDATE_DEPARTMENT_GROUP_REQUEST,
  UPDATE_DEPARTMENT_GROUP_SUCCESS,
  UPDATE_DEPARTMENT_GROUP_FAILURE,
  DELETE_DEPARTMENT_GROUP_REQUEST,
  DELETE_DEPARTMENT_GROUP_SUCCESS,
  DELETE_DEPARTMENT_GROUP_FAILURE,
  DEPARTMENT_GROUP_FORM_ERROR,
  DEPARTMENT_GROUP_FORM_SUCCESS,
  SET_DEPARTMENT_GROUP_EDIT,
  CLEAR_DEPARTMENT_GROUP_EDIT,
} from '../../../../types/masters/department/departmentGroup/departmentGroupTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingDepartmentGroup: null,
};

const departmentGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENT_GROUP_REQUEST:
    case ADD_DEPARTMENT_GROUP_REQUEST:
    case UPDATE_DEPARTMENT_GROUP_REQUEST:
    case DELETE_DEPARTMENT_GROUP_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_DEPARTMENT_GROUP_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_DEPARTMENT_GROUP_SUCCESS:
    case UPDATE_DEPARTMENT_GROUP_SUCCESS:
    case DELETE_DEPARTMENT_GROUP_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_DEPARTMENT_GROUP_FAILURE:
    case ADD_DEPARTMENT_GROUP_FAILURE:
    case UPDATE_DEPARTMENT_GROUP_FAILURE:
    case DELETE_DEPARTMENT_GROUP_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_DEPARTMENT_GROUP_EDIT:
      return { ...state, editingDepartmentGroup: action.payload };
    case CLEAR_DEPARTMENT_GROUP_EDIT:
      return { ...state, editingDepartmentGroup: null };
    default:
      return state;
  }
};

export default departmentGroupReducer; 